import './index.scss'
import {CheckIcon, ErrorIcon} from '../../../icons'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const Alert = () => {
    return (
        <ToastContainer position="top-center" autoClose={process.env.REACT_APP_ALERT_DURATION} toastOptions={{
            success: {
                icon: <span><CheckIcon/></span>
            },
            error: {
                icon: <span><ErrorIcon/></span>
            }
        }}/>
    )
}

export default Alert
